import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Configuración global de la aplicación
window.API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
window.APP_VERSION = process.env.REACT_APP_VERSION || '2.0.0';
window.APP_NAME = process.env.REACT_APP_NAME || 'Plataforma Regulatoria Farmacéutica';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);